<template>
    <a-button @click="visible = true" icon="akar-icons:plus" class="!tw-border-b tw-scale-75  tw-ms-auto lg:tw-m-0" intent="icon"></a-button>

    <a-popup :visible="visible" @cancel="onCancel">
        <div
            class="tw-mx-auto tw-w-[95%] md:tw-max-w-[800px]  tw-h-fit tw-overflow-auto tw-flex tw-flex-col tw-border tw-border-solid dark:tw-border-gray-400 tw-border-gray-300 tw-shadow-md tw-my-16 tw-rounded">
            <div>
                <div
                    class="tw-p-4 tw-text-lg tw-flex tw-items-center tw-gap-2 tw-border-b tw-border-solid tw-font-semibold dark:tw-text-gray-700 tw-text-gray-500 dark:tw-bg-gray-100 tw-bg-gray-50">
                    <span>{{ $t("common.product-offer") }}</span>
                </div>

                <div class="tw-p-5 tw-bg-white tw-flex-1">
                    <div class="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-gap-y-0">
                        <div class="tw-col-span-12 md:tw-col-span-6">
                            <FormField v-model="offer.quantity" :label="$t('fields.quantity')" type="number"
                                :error="errors.quantity &&
                                    $t('errors.' + errors.quantity, {
                                        field: $t('fields.quantity'),
                                    })
                                    " />
                        </div>

                        <div class="tw-col-span-12 md:tw-col-span-6">
                            <FormField v-model="offer.price" :label="$t('fields.price')" type="number"
                                :error="errors.price &&
                                    $t('errors.' + errors.price, {
                                        field: $t('fields.price'),
                                    })
                                    " />
                        </div>

                        <div class="tw-col-span-12 md:tw-col-span-12">
                            <FormField v-model="offer.note" :label="$t('fields.note')" type="textarea"
                                :error="errors.note &&
                                    $t('errors.' + errors.note, {
                                        field: $t('fields.note'),
                                    })
                                    " />
                        </div>

                    </div>
                </div>

                <div
                    class="tw-p-4 tw-text-lg tw-border-t tw-justify-end tw-border-solid tw-font-medium tw-flex dark:tw-text-gray-700 tw-text-gray-500 tw-items-center tw-gap-4 dark:tw-bg-gray-100 tw-bg-gray-50">
                    <a-button @click="onCancel" class="tw-min-w-[120px]" intent="simple">{{
                        $t("buttons.cancel") }}</a-button>
                    <a-button  @click="onCreate" class="tw-min-w-[120px]">{{
                        $t("buttons.create") }}</a-button>
                </div>
            </div>
        </div>
    </a-popup>

</template>

<script setup>
import FormField from "@/components/form/FormField";
import { ref, defineEmits } from 'vue';

const visible = ref(false);
const  emit = defineEmits(['created']);

const errors = ref({});
const offer = ref({
    note: '',
    quantity: 0,
    price: 0,
});

const onCreate = () => {
    console.log(offer.value);
    if(!offer.value.quantity || !offer.value.price) {
        errors.value = {
            quantity: !offer.value.quantity ? 'required' : null,
            price: !offer.value.price ? 'required' : null,
        };
        return;
    }
    // add random id to offer
    offer.value.id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

    errors.value = {};
    offer.value.created = true;
    emit('created', offer.value);
    offer.value = {
        note: '',
        quantity: 0,
        price: 0,
    };
    
    visible.value = false;
}

const onCancel = () => {
    visible.value = false;
}


</script>

<style></style>